import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  Typography,
  Avatar,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import MDBox from "components/MDBox";
import Ellipse1 from "assets/images/home-page-images/Ellipse1.png";
import Ellipse2 from "assets/images/home-page-images/User.png";

const testimonialsData = [
  {
    name: "Maria Lopez",
    title: "Restaurant owner",
    feedback:
      "Since we started using this AI restaurant marketing platform, our review management has been effortless. The real-time guest intelligence and local insights helped us tailor our promotions perfectly.",
    avatar: Ellipse1,
  },
  {
    name: "James Carter",
    title: "General Manager",
    feedback:
      "TavloAI transformed the way we approach restaurant marketing. The business intelligence tools gave us a clear picture of what our customers want, while the reputation management features ensured we always stay ahead of negative reviews.",
    avatar: Ellipse2,
  },
  {
    name: "John Doe",
    title: "CEO, Example Inc.",
    feedback:
      "Since we started using this AI restaurant marketing platform, our review management has been effortless.",
    avatar: "https://randomuser.me/api/portraits/men/3.jpg",
  },
  {
    name: "Jane Smith",
    title: "CTO, TechCorp",
    feedback:
      "TavloAI transformed the way we approach restaurant marketing. The business intelligence tools gave us a clear picture.",
    avatar: "https://randomuser.me/api/portraits/women/4.jpg",
  },
  {
    name: "David Lee",
    title: "Engineer, CodeCraft",
    feedback: "Helped our team collaborate and grow faster than ever.",
    avatar: "https://randomuser.me/api/portraits/men/5.jpg",
  },
];

const Testimonials = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = isMobile ? 1 : 2;

  const totalPages = Math.ceil(testimonialsData.length / visibleCount);

  useEffect(() => {
    setStartIndex(0);
  }, [isMobile]);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - visibleCount, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) =>
      Math.min(prev + visibleCount, testimonialsData.length - visibleCount)
    );
  };

  const handleDotClick = (page) => {
    setStartIndex(page * visibleCount);
  };

  const currentPage = Math.floor(startIndex / visibleCount);

  const visibleTestimonials = testimonialsData.slice(
    startIndex,
    startIndex + visibleCount
  );

  return (
    <Box sx={{ position: "relative", overflow: "visible" }}>
      {/* Left Arrow */}
      {startIndex > 0 && (

        <IconButton
           onClick={handlePrev}
          sx={{
            position: "absolute",
            top: "45%",
            left: { xs: "-15px", sm: "-50px" },
            transform: "translateY(-50%)",
            backgroundColor: "#F47C00",
            color: "#fff",
            boxShadow: 2,
            zIndex: 2,
            width: { xs: "20px", sm: "40px", md: "35px" },
            height: { xs: "20px", sm: "40px", md: "35px" },
            fontSize: { xs: "8px", sm: "20px", md: "13px" },
            "&:hover": {
              backgroundColor: "#f98e24",
            },
          }}
        >
          <ArrowBackIos
           
          />
        </IconButton>
       
      )}

      {/* Right Arrow */}
      {startIndex + visibleCount < testimonialsData.length && (
       

        <IconButton
          onClick={handleNext}
          sx={{
            position: "absolute",
            top: "45%",
            right: { xs: "-15px", sm: "-50px" },
            transform: "translateY(-50%)",
            backgroundColor: "#F47C00",
            color: "#fff",
            boxShadow: 2,
            zIndex: 2,
            width: { xs: "20px", sm: "40px", md: "35px" },
            height: { xs: "20px", sm: "40px", md: "35px" },
            fontSize: { xs: "8px", sm: "20px", md: "13px" },
            "&:hover": {
              backgroundColor: "#f98e24",
            },
          }}
        >
          <ArrowForwardIos
           
          />
        </IconButton>
      )}

      {/* Testimonials */}
      <MDBox
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          gap: 2,
        }}
      >
        {visibleTestimonials.map((testimonial, index) => (
          <MDBox
            key={index}
            sx={{
              width: {
                xs: "96%",
                md: "48%",
              },
            }}
          >
            <Card
              sx={{
                pl: { xs: 2, sm: 2, md: 8 },
                pr: { xs: 1.3, sm: 2, md: 3 },
                pt: { xs: 3, sm: 2, md: 6 },
                pb: { xs: 2, sm: 2, md: 4 },
                borderRadius: 5,
                boxShadow: " 0px 4px 44px 0px #00000073",
                height: "100%",
              }}
            >
              <MDBox
                display="flex"
                alignItems="flex-start"
                sx={{
                  gap: { xs: 1, sm: 6, md: 13 },
                }}
              >
                {/* Avatar Section */}
                <MDBox sx={{ position: "relative", minWidth: 70 }}>
                  <Box
                    sx={{
                      width: { xs: 60, sm: 90, md: 130 },
                      height: { xs: 60, sm: 90, md: 130 },
                      borderRadius: "50%",
                      backgroundColor: "#F47C00",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mt: { xs: 3, sm: 0, md: 0 },
                    }}
                  />
                  <MDBox
                    sx={{
                      position: "absolute",
                      top: { xs: 30, sm: 25, md: 15 },
                      left: { xs: 8, sm: 12, md: 15 },
                    }}
                  >
                    <Avatar
                      src={testimonial.avatar}
                      alt={testimonial.name}
                      sx={{
                        width: { xs: 60, sm: 90, md: 130 },
                        height: { xs: 60, sm: 90, md: 130 },
                        boxShadow: "0px 4px 20px 0px #00000073",
                      }}
                    />
                  </MDBox>
                </MDBox>

                {/* Text Section */}
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight:200,
                      fontSize: { xs:"9.7px", sm:"9.7px", md: "11.7px",},
                      lineHeight: { xs: 1.3, sm: 0.9, md: 1.7 },
                      fontStyle: "italic",
                      mb: 1,
                      color: "#000",
                      fontFamily: "Poppins",
                      height: "70px",
                    }}
                  >
                    “{testimonial.feedback}”
                  </Typography>
                  <Typography
                    fontWeight={600}
                    // fontSize="1.2rem"
                    sx={{
                      fontSize: { xs: "16px", sm: "14px", md: "14px" },
                      color: "#000",
                      lineHeight: { xs: 1, sm: 1.4, md: 1.4 },
                      mt: {
                        xs: 2,
                        sm: 2,
                        md: 4,
                      },
                      fontFamily: "Poppins",
                    }}
                  >
                    {testimonial.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontSize: { xs: "12px", sm: "14px", md: "14px" },
                      color: "#000",
                      fontFamily: "Poppins",
                    }}
                  >
                    {testimonial.title}
                  </Typography>
                </Box>
                <MDBox
                  sx={{ position: "absolute", bottom: "25%", right: "15%" }}
                >
                  <MDBox
                    sx={{
                      width: { xs: "15px", sm: "20px", md: "25px" },
                      height: { xs: "15px", sm: "20px", md: "25px" },
                      backgroundColor: "#F47C00",
                      borderRadius: "50%",
                    }}
                  ></MDBox>
                </MDBox>
                <MDBox
                  sx={{
                    position: "absolute",
                    bottom: "20%",
                    left: {
                      xs: "19%",
                      sm: "25%",
                      md: "35%",
                    },
                  }}
                >
                  <MDBox
                    sx={{
                      width: { xs: "15px", sm: "20px", md: "25px" },
                      height: { xs: "15px", sm: "20px", md: "25px" },
                      backgroundColor: "#318BEC",
                      borderRadius: "50%",
                    }}
                  ></MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </MDBox>
        ))}
      </MDBox>

      {/* Dots */}
      <MDBox
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 3,
          gap: 1,
        }}
      >
        {Array.from({ length: totalPages }).map((_, index) => (
          <Box
            key={index}
            onClick={() => handleDotClick(index)}
            sx={{
              width: { xs: 15, sm: 20, md: 30 },
              height: 3,
              backgroundColor: index === currentPage ? "#000" : "#ccc",
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#f98e24",
              },
            }}
          />
        ))}
      </MDBox>
    </Box>
  );
};

export default Testimonials;
